export const { REACT_APP_STOP_BASE_URL } = process.env;
export const CBP_INVOICE_HISTORY_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/ProviderInvoiceHistory`;
export const CBP_INVOICE_LOCK_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/SentDate?CBPIds=`;
export const CBP_ORG_INVOICE_LOCK_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/OrgSentDate?CBPIds=`;
export const CBP_INVOICE_ADD_HISTORY_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/AddHistory?invoiceIds=`;
export const CBP_INVOICE_DELETE_HISTORY_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/DeleteHistory?historyIds=`;
export const CBP_INVOICE_FAX_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/FaxDate`;
export const SET_RATES_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/SetRates?selectedMonth=`;
export const CREATE_INVOICES_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/CreateInvoices?selectedMonth=`;
export const PROVIDER_INVOICE_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/ProviderInvoices?selectedMonth=`;
export const OUT_OF_MONTH_TREATMENTS_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/OutOfMonth?selectedMonth=`;
export const CREDITED_TREATMENTS_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/Credited?selectedMonth=`;
export const PARTICIPANTS_URL = `${REACT_APP_STOP_BASE_URL}api/participants?`;
export const PARTICIPANTS_SEARCH = `${REACT_APP_STOP_BASE_URL}api/participants/search?searchText=`;
export const PARTICIPANT_URL = `${REACT_APP_STOP_BASE_URL}api/participants`;
export const PARTICIPANT_DELETE_URL = `${REACT_APP_STOP_BASE_URL}api/participants`;
export const PARTICIPANT_EPISODE_DELETE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/episode`;
export const ADD_PARTICIPANT_REFERENCE_DATA = `${REACT_APP_STOP_BASE_URL}api/participants/referencedata`;
export const ADD_PARTICIPANT_FORM_URL = `${REACT_APP_STOP_BASE_URL}api`;
export const PARTICIPANTS_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/participants/referencedata`;
export const PARTICIPANTS_EPISODE_DETAIL_URL = `${REACT_APP_STOP_BASE_URL}api/participants/`;
export const EPISODE_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/episodes?`;
export const EPISODE_BASE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;
export const EPISODE_AUTH_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;
export const ACTIVITIES_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/activities`;
export const ACTIVITY_DELETE_URL = `${REACT_APP_STOP_BASE_URL}api/Activity`;
export const AUTHORIZATION_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/authorizations`;
export const AUTHORIZATION_MAKE_ADJUSTMENT = `${REACT_APP_STOP_BASE_URL}api/authorization/make-adjustment`;
export const CDCR_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/cdcr`;
export const CDCR_REPORT_URL = `${REACT_APP_STOP_BASE_URL}api/cdcrrpt`;
export const TREATMENT_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/treatments`;
export const VERIFICATION_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/verifications?`;
export const CBP_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/CBP/list?`;
export const CONTACT_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/Contact/contactList?`;
//Referral Tab
export const EPISODE_REFERRAL_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;
export const EPISODE_REFERRAL_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/reference/referencedata`;
export const EPISODE_REFERRAL_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/reference`;
//ProfA1 Tab
export const EPISODE_PROFA_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;
export const PROFA1_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/profA1/referencedata`;
export const PROFA1_REFERRAL_UPDATE_DATA = `${REACT_APP_STOP_BASE_URL}api/episodes/ProfA1`;
//profA2 tab
export const EPISODE_PROFA2_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;
export const PROFA2_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/profA2/referencedata`;
export const PROFA2_REFERRAL_UPDATE_DATA = `${REACT_APP_STOP_BASE_URL}api/episodes/ProfA2`;
//ProfB1 Tab
export const EPISODE_PROFB1_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;
export const EPISODE_PROFB1_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/profB1/referencedata`;
export const EPISODE_PROFB1_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/ProfB1`;
//ProfB2 Tab
export const EPISODE_PROFB2_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;
export const EPISODE_PROFB2_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/profB2/referencedata`;
export const EPISODE_PROFB2_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/ProfB2`;
//Activities Tab
export const EPISODE_ACTIVITIES_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;
export const EPISODE_ACTIVITIES_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/activities/referencedata`;
export const EPISODE_ACTIVITIES_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;
//Quality Assurance Tab
export const EPISODE_QUALITY_ASSURANCE_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;
export const EPISODE_QUALITY_ASSURANCE_DETAIL_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/QAReviews/`;
export const EPISODE_QUALITY_ASSURANCE_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/QAReviews/referencedata`;
export const EPISODE_QUALITY_ASSURANCE_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;

//aor/cm Tab
export const EPISODE_AOR_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;
export const EPISODE_AORCM_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/AORCMs/referencedata`;

//stsAlert
export const EPISODE_STS_ALERT_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/StatusAlert`;
export const EPISODE_STS_ALERT_PRINT_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/StatusAlertPrint/`;
export const EPISODE_STS_ALERT_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/StatusAlert/referencedata`;
export const EPISODE_STS_ALERT_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;

//2284 Tab
export const EPISODE_2284_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/2284/incidents`;
export const EPISODE_2284_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/2284/referencedata`;
export const EPISODE_2284_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/2284/incidentReport`;
export const EPISODE_2284_DELETE_URL = `${REACT_APP_STOP_BASE_URL}api/2284/incidentReport`;
export const EPISODE_2284_REPORTING_PROGRAM_ORG_ADDRESS_URL = `${REACT_APP_STOP_BASE_URL}api/2284/reportingProgramChange`;

//Oras
export const EPISODE_ORAS_CST = `${REACT_APP_STOP_BASE_URL}api/episodes/OrasCST`;
export const EPISODE_ORAS_RT = `${REACT_APP_STOP_BASE_URL}api/episodes/OrasRT`;
export const EPISODE_ORAS_SRT = `${REACT_APP_STOP_BASE_URL}api/episodes/OrasSRT`;
export const EPISODE_ORAS_DCH = `${REACT_APP_STOP_BASE_URL}api/episodes/OrasDch`;
export const EPISODE_ORAS_CST_DELETE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/OrasCST`;
export const EPISODE_ORAS_RT_DELETE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/OrasRT`;
export const EPISODE_ORAS_SRT_DELETE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/OrasSRT`;
export const EPISODE_ORAS_DCH_DELETE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/OrasDch`;

//Transport Tab
export const EPISODE_TRANSPORT_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;
export const EPISODE_TRANSPORT_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/transport/referencedata`;
export const EPISODE_TRANSPORT_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/transport`;
export const SCHEDULE_URL = `${REACT_APP_STOP_BASE_URL}api/schedule`;

//new episode
export const NEW_EPISODE_REFERENCE_DATA = `${REACT_APP_STOP_BASE_URL}api/participants/Episode/referencedata`;
export const NEW_EPISODE_UPDATE_DATA = `${REACT_APP_STOP_BASE_URL}api/participants`;

//CBP
export const CBP_CASE_MANAGER_LIST = `${REACT_APP_STOP_BASE_URL}api/CBP`;
export const CBP_CASE_MANAGER_DETAIL = `${REACT_APP_STOP_BASE_URL}api/CBP/casemanager`;
export const CBP_CASE_MANAGER_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/CBP`;
export const CBP_CASE_MANAGER_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/CBP/casemanager/list/referencedata`;
export const CBP_INVOICES_LIST = `${REACT_APP_STOP_BASE_URL}api/CBP`;
export const CBP_RATES_LIST = `${REACT_APP_STOP_BASE_URL}api/CBP`;
export const CBP_RATES_REFERENCE_DATA = `${REACT_APP_STOP_BASE_URL}api/CBP/rte/list/referencedata`;
export const CBP_FORM_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/CBP`;
export const CBP_FORM_REFERENCE_DATA = `${REACT_APP_STOP_BASE_URL}api/CBP/referencedata`;
export const CBP_FORM_PUT_AND_POST_URL = `${REACT_APP_STOP_BASE_URL}api/CBP`;

//Auth
export const EPISODE_AUTHORIZATION_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;
export const EPISODE_AUTHORIZATION_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/Auth`;
export const EPISODE_AUTHORIZATION_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/Auth`;
export const EPISODE_CBP_AUTHORIZATION_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes`;
export const EPISODE_AUTHORIZATION_PDF_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/STOPAUTH`;
export const EPISODE_CBP_AUTHORIZATION_PDF_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/CBPAUTH`;
export const COMPLETION_REPORT_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/completion-ratio`;
export const COMPLETION_REPORT_AGE_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/completion-ratio-age`;
export const COMPLETION_REPORT_ETHNICITY_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/completion-ratio-ethnicity`;
export const COMPLETION_REPORT_FUNDING_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/completion-ratio-funding`;

//verification
export const VERIFICATION_BASE_URL = `${REACT_APP_STOP_BASE_URL}api/Verification`;
export const VERIFICATION_REFERENCE_DATA = `${REACT_APP_STOP_BASE_URL}api/verifications/referencedata`;
export const VERIFICATION_INSERT = `${REACT_APP_STOP_BASE_URL}api/verifications/insert`;
export const VERIFICATION_REPORT_PROVIDERS = `${REACT_APP_STOP_BASE_URL}api/verifications/print/providers`;
export const VERIFICATION_REPORT_DETAILS = `${REACT_APP_STOP_BASE_URL}api/verifications/print/details`;
export const VERIFICATION_MASTER_REFERENCE_DATA = `${REACT_APP_STOP_BASE_URL}api/Verification/verify/referencedata`;

//Contacts
export const CONTACT_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/Contact/referencedata`;
export const CONTACT_FORM_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/Contact/details`;
export const CONTACT_ORGANIZATION_ADDRESS_URL = `${REACT_APP_STOP_BASE_URL}api/Contact/orgAddress`;
export const CONTACT_FORM_PUT_AND_POST_URL = `${REACT_APP_STOP_BASE_URL}api/Contact`;
export const CONTACT_REFERRAL_SOURCES_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/Contact/referralSources`;
export const USERS_URL = 'https://5gc1es6iwg.execute-api.us-west-2.amazonaws.com/prod/users';

//Organization
export const ORGANIZATION_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/referencedata`;
export const ORGANIZATION_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/organization/list?`;
export const ORGANIZATION_FORM_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/details`;
export const ORGANIZATION_ADDRESS_AND_CONTACTS_FORM_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/addressContacts`;
export const ORGANIZATION_CONTACTS_FORM_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/contact`;
export const ORGANIZATION_SUBSIDARIES_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/subsidaries`;
export const ORGANIZATION_COMPLIANCE_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/compliance`;
export const ORGANIZATION_COMPLIANCE_ASSOCIATED_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/associated/compliance`;
export const ORGANIZATION_SAP_FORM_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/sap/details`;
export const ORGANIZATION_SAP_FORM_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/sap`;
export const ORGANIZATION_SAP_INVOICES_ACTIVITIES_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/sap/invoices/activities`;
export const ORGANIZATION_SAP_ACTIVITIES_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/sap/activities`;
export const ORGANIZATION_INSTITUTION_FORM_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/institution`;
export const ORGANIZATION_REGION_FORM_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/region`;
export const ORGANIZATION_COMMENTS_FORM_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/Organization/comments`;

//Invoice
export const INVOICE_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/MasterData`;
export const INVOICE_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/Records/Month`;
export const INVOICE_BASE_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/`;
export const INVOICE_TRANSPORT_URL = `${REACT_APP_STOP_BASE_URL}api/transportation/list`;
export const CBP_INVOICE_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/list?CBPIds=`;
export const ORG_INVOICE_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/OrgInvoiceList`;
export const ORG_INVOICE_DETAILS_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice/OrgInvoiceDetails?orgInvIds=`;
export const CBP_INVOICE_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/Invoice`;

//Report
export const REPORT_LIST_URL = `${REACT_APP_STOP_BASE_URL}api/reports/list?`;
export const REPORT_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/reports`;
export const REPORT_DIRECTORY_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/directory/`;
export const REPORT_WEEKLY_PAROLE_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/weekly/`;
export const PROVIDER_ADM_RATES_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/provider-adm-rates`;
export const PROVIDER_REF_CONTACTS_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/provider-ref-contacts`;
export const ADHOC_QUERY_URL = `${REACT_APP_STOP_BASE_URL}api/Query/AdHoc`;

//Cmp
export const EPISODE_CMP_LIST = `${REACT_APP_STOP_BASE_URL}api/cmp/list`;
export const EPISODE_CMP_REFERENCE_DATA_URL = `${REACT_APP_STOP_BASE_URL}api/cmp/referencedata`;
export const EPISODE_CMP_UPDATE_URL = `${REACT_APP_STOP_BASE_URL}api/cmp/detail`;
export const EPISODE_CMP_DELETE_URL = `${REACT_APP_STOP_BASE_URL}api/episodes/Cmp`;

//Shared
export const COUNTY_LIST = `${REACT_APP_STOP_BASE_URL}api/County/list`;

export const AUTHORIZATION_REPORTS_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/pop`;
export const AUTHORIZATION_REPORTS_ADMIT_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/calomsadm`;
export const AUTHORIZATION_REPORTS_DISCHARGE_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/calomsdch`;
export const AUTHORIZATION_REPORTS_REFERRAL_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/referral?episodeId=`;
export const AUTHORIZATION_REPORTS_CALOMSACT_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/calomsact?authIds=`;
export const AUTHORIZATION_REPORTS_INCIDENT_REPORT_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/2284?irId=`;
export const AUTHORIZATION_REPORTS_TRANSPORT_URL = `${REACT_APP_STOP_BASE_URL}api/Reports/transport?transportId=`;
export const AUTHORIZATION_LIST_PAGESIZE_URL = `?1=1&PageNumber=1&PageSize=500`;

export const dateFormatShort = 'MM/DD/YY';
export const dateFormat = 'MM/DD/YYYY';
export const dateFormat2 = 'MM / DD / YYYY';
export const dateTimeFormat = 'MM/DD/YYYY h:mm:ss A';
export const dateFormatPdf = 'MM/DD/YYYY';
export const formDateFormat = 'YYYY-MM-DD';
export const dateFormatWeek = 'YYYY-MM-DDT00:00:00';
export const fieldRequired = 'This field is required.';
export const negativeValue = 'negative values are not allowed.';
export const maxLength = 'max length is';
export const validEmail = 'You must enter a valid email';
export const commonDecimalText =
  'This field should be in decimals and should not allow negative values.';
export const noNegitiveValue = 'This field does not allow negative values.';
export const subMenuDetail = 'Details';
export const subMenuList = 'List';
export const westCarePdfHeading = 'WestCare Services Authorization';
export const westCarePdfTitle = `Fiscal document that authorizes placements with a Community
Based Provider and insures the provider of funding.`;

export const paginationSize = [10, 50, 250, 500];

export const transErrorMessage1 =
  'Enter the [Transport to be completed by Organization] which will perform the transportation.';
export const transErrorMessage2 =
  'Enter the [Transport to be completed by Organization] which performed the transportation.';
export const transErrorMessage3 =
  'Enter the [Transport to be completed by Organization] which attempted to complete/perform the transportation.';
export const transErrorMessage4 =
  'Enter the [Person Performing Pick Up at the Initial Departure Location].';
export const transErrorMessage5 = 'Enter the [Initial Departure Date].';
export const transErrorMessage6 =
  'You have entered an Outcome Code but have not entered the Actual Departure Date.  Please either enter the Actual Departure Date or remove the Outcome Code.';
export const transErrorMessage7 =
  'The Actual Departure Date must be the same as the Initial Departure Date entered';
export const transErrorMessage8 =
  'You have entered an Actual Departure Date but have not entered the Outcome Code.  Please either enter the Outcome Code or remove the Actual Departure Date.';
export const transErrorMessage9 =
  'You have entered the Actual Staff Time but have not entered the Actual Mileage.';
export const transErrorMessage10 =
  'You have entered the Actual Mileage but have not entered the Actual Staff Time.';

export const cbpListEnable = 'To enable this button please click on Cbp list';
export const referalNote = `Notifies the STOP Coordinator and pre-selected Community Based Provider(s) of the participant's intent for placement or refusal of treatment. It also as certains if the concerned Community Based Provider(s) will conditionally accept the participant and will work to provide transition to the provider upon parole. Initial referrals must be completed for every SAP participant regardless of intent to participate in continuing care.`;
export const calOmsActPleaseReadText = `PLEASE READ: A Check mark next to a Admit Date or a Discharge Date indicates that the Admit or Discharge is not received. If an Admit or Discharge was received incomplete it will be noted in the comment field and remain checked as not received until a complete Admit or Discharge not received.`;

export const paperProps = {
  sx: {
    maxWidth: 'unset',
    width: '400px',
    maxHeight: 'unset',
  },
};

export const paperProps2 = {
  sx: {
    maxWidth: 'unset',
    width: '800px',
    maxHeight: 'unset',
  },
};

export const paperProps3 = {
  sx: {
    maxWidth: 'unset',
    width: '1200px',
    maxHeight: '90vh',
    '&::-webkit-scrollbar': { display: 'none' },
  },
};

export const backDrop = { zIndex: (theme) => theme.zIndex.drawer + 1 };

export const stopYesNoOptions = [
  {
    value: true,
    booleanText: 'Yes',
  },
  {
    value: false,
    booleanText: 'No',
  },
];

export const stopYesNoIdOptions = [
  {
    yesNoId: 1,
    booleanIdText: 'Yes',
  },
  {
    yesNoId: 0,
    booleanIdText: 'No',
  },
];

export const genderData = [
  {
    id: 'F',
    value: 'Female',
  },
  {
    id: 'M',
    value: 'Male',
  },
];

export const yesNoDropdown = [
  {
    id: true,
    value: 'Yes',
  },
  {
    id: false,
    value: 'No',
  },
];

export const mfDropdown = [
  {
    id: 'M',
    value: 'Male',
  },
  {
    id: 'F',
    value: 'Female',
  },
];

export const substanceUseHistory = [
  {
    option: 'Alcohol',
  },
  {
    option: 'Methamphetamine',
  },
  {
    option: 'Cocaine',
  },
  {
    option: 'Heroin',
  },
  {
    option: 'Marijuana/Hash',
  },
  {
    option: 'Ecstacy',
  },
  {
    option: 'PCP',
  },
  {
    option: 'LSD/Hallucinogens',
  },
  {
    option: 'Inhalants',
  },
  {
    option: 'Prescription',
  },
  {
    option: 'Poly-Drug User',
  },
];

export const pAllConcerns = [
  {
    option: 'None',
  },
  {
    option: 'Sex',
  },
  {
    option: 'Arson',
  },
  {
    option: 'Violence',
  },
  {
    option: 'Child Abuse',
  },
  {
    option: 'Domestic Violence',
  },
  {
    option: 'POC',
  },
  {
    option: 'Weapons',
  },
  {
    option: 'Gangs',
  },
  {
    option: 'Enemies',
  },
  {
    option: 'ADA',
  },
  {
    option: 'Medical',
  },
  {
    option: 'Psychiatric',
  },
  {
    option: 'Victims',
  },
  {
    option: 'Elder Abuse',
  },
];

export const pAllDirectionsForPlacement = [
  {
    option: 'None',
  },
  {
    option: 'No Co-Ed Program',
  },
  {
    option: 'No Contact with Minors',
  },
  {
    option: 'No FOTEP',
  },
  {
    option: 'Medical Concerns(Explain)',
  },
];

export const QAOptions = [
  {
    label: 'Yes',
    value: 1,
  },
  {
    label: 'No',
    value: 0,
  },
  {
    label: 'Unknown',
    value: 2,
  },
];

export const missedAppointmentOnOptions = [
  {
    label: 'Intake/Assessment',
    value: 1,
  },
  {
    label: 'Individual',
    value: 2,
  },
  {
    label: 'Group',
    value: 3,
  },
  {
    label: 'Other',
    value: 4,
  },
  {
    label: 'Clear',
    value: 99,
  },
];

export const admittedToProgramOnOptions = [
  {
    label: 'RES',
    value: 1,
  },
  {
    label: 'SLE',
    value: 2,
  },
  {
    label: 'OPT',
    value: 3,
  },
  {
    label: 'SMD',
    value: 4,
  },
  {
    label: 'Clear',
    value: 99,
  },
];

export const dischargeWasOptions = [
  {
    label: 'Successful Completion',
    value: 1,
  },
  {
    label: 'Program Termination',
    value: 2,
  },
  {
    label: 'Medical',
    value: 3,
  },
  {
    label: 'Removed by parole agent',
    value: 4,
  },
  {
    label: 'Other',
    value: 5,
  },
  {
    label: 'Clear',
    value: 99,
  },
];

export const authTypeRadio = [
  {
    label: 'Non-SAP',
    value: 6,
  },
  {
    label: 'SAP',
    value: 8,
  },
  {
    label: 'Clear',
    value: 99,
  },
];

export const emptyMonth = [
  {
    id: '',
    value: '',
  },
];

export const admitOrGroup = [
  {
    id: null,
    value: '<Clear Entry>',
  },
  {
    id: 15,
    value: 'Admit (Group or Individual)',
  },
  {
    id: 17,
    value: 'No Show',
  },
];

export const medicalValue = [
  {
    id: null,
    value: '<Clear Entry>',
  },
  {
    id: 18,
    value: 'Individual or Residential',
  },
  {
    id: 2,
    value: 'Medical (3 Days Only)',
  },
  {
    id: 6,
    value: 'zAttended',
  },
];

export const missedValue = [
  {
    id: null,
    value: '<Clear Entry>',
  },
  {
    id: 18,
    value: 'Individual or Residential',
  },
  {
    id: 2,
    value: 'Medical (3 Days Only)',
  },
  {
    id: 3,
    value: 'Missed',
  },
  {
    id: 6,
    value: 'zAttended',
  },
];

export const groupValue = [
  {
    id: null,
    value: '<Clear Entry>',
  },
  {
    id: 18,
    value: 'Individual or Residential',
  },
  {
    id: 19,
    value: 'Group',
  },
  {
    id: 2,
    value: 'Medical (3 Days Only)',
  },
  {
    id: 6,
    value: 'zAttended',
  },
];

export const individualOrRes = [
  {
    id: null,
    value: '<Clear Entry>',
  },
  {
    id: 18,
    value: 'Individual or Residential',
  },
  {
    id: 6,
    value: 'zAttended',
  },
];

export const onlyMedical = [
  {
    id: null,
    value: '<Clear Entry>',
  },
  {
    id: 2,
    value: 'Medical (3 Days Only)',
  },
];

export const IGCredit = [
  {
    id: null,
    value: '<Clear Entry>',
  },
  {
    id: 23,
    value: 'Credit',
  },
];
